import { useEffect } from "react";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { trackGTMEvent } from "lib/utils";
import { registerHubspotFormSubmitListener } from "lib/helpers/hubspot";

const HubSpotContactFormId = "df7f10b3-4e79-4dc0-893b-217f810dcaec";
const FormtSubmitTrackEventName = "Contact Us Submit";

export default function ContactForm() {
  const { track } = useMixpanelTracking();

  useEffect(() => {
    const trackFormSubmit = async () => {
      const clickLocation = window.location.href;

      await track(FormtSubmitTrackEventName, {
        clickLocation,
      });
      trackGTMEvent({
        event: FormtSubmitTrackEventName,
        clickLocation,
      });
    };

    // Register listener immediately - it will wait for HubSpot messages
    const cleanup = registerHubspotFormSubmitListener(
      HubSpotContactFormId,
      trackFormSubmit
    );

    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20037605",
          formId: HubSpotContactFormId,
          target: `#hubspotForm`,
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      cleanup(); // Remove event listener
      document.body.removeChild(script);
    };
  }, [track]);

  return <div id="hubspotForm" />;
}
